<template>
  <div class="filterHeader">
    <div class="videoWrapper">
      <OapVideo
        v-bind="video"
        :sources="sources"
        :placeholder-background="proxy.background"
        :placeholder-class="['filterHeader__background']"
        :controls-position="videoControlsPosition"
      ></OapVideo>
      <h1 class="filterHeader__heading heading1">{{ proxy.title }}</h1>
    </div>
    <article
      v-if="proxy.description"
      itemscope
      itemtype="http://schema.org/Article"
      class="filterHeader__information"
    >
      <div class="filterHeader__content filterHeader__column" data-tag-wrapper>
        <slot></slot>
        <div class="filterHeader__descriptionWrapper">
          <div
            id="filterDescription"
            ref="filterDescription"
            class="filterHeader__description"
            :class="{ '--expanded': expanded }"
            v-html="getTruncatedText(proxy.description)"
          ></div>
          <span v-if="isTextTruncated && !expanded && proxy.description.length > charLimit">
            ...
          </span>
          <button v-if="buttonEnabled" class="filterHeader__readButton" @click="showText()">
            {{ expanded ? readlessText : readmoreText }}
            <span class="is-sr-only">{{ expanded ? readlessText : readmoreText }}</span>
          </button>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import OapVideo from '../../../../../Foundation/Core/code/Scripts/OapVideo/OapVideo';

import eventBus from '@loreal/eventbus-js';
import { mapGetters } from 'vuex';

import { HERO_VIDEO_UPDATE } from '../constants/eventNames';

export default {
  name: 'FilterHeaderContainer',
  components: {
    OapVideo,
  },
  props: {
    video: {
      type: Object,
      default: () => {},
    },
    background: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    isReadmoreEnabled: {
      type: Boolean,
      default: false,
    },
    readmoreCharLimiter: {
      type: String,
      default: '',
    },
    readmoreText: {
      type: String,
      default: '',
    },
    readlessText: {
      type: String,
      default: '',
    },
    videoControlsPosition: {
      type: String,
      default: 'bottom-left',
    },
  },
  data() {
    return {
      proxy: { ...this.$props },
      buttonText: '',
      expanded: false,
      charLimit: parseInt(this.readmoreCharLimiter),
      buttonEnabled: false,
      mobileScreenWidthEnd: 719,
      isMobileView: false,
      isTextTruncated: false,
    };
  },
  computed: {
    sources() {
      return this.proxy?.video?.sources ?? {};
    },
    ...mapGetters('filterList', ['getFilterDataset']),
  },
  watch: {
    isMobileView() {
      this.getLineCount();
    },
  },
  created() {
    eventBus.on(HERO_VIDEO_UPDATE, () => {
      this.proxy = this.getFilterDataset.banner ? this.getFilterDataset.banner : this.proxy;
    });
  },
  mounted() {
    if (this.isReadmoreEnabled) {
      this.showTruncatedText();

      window.addEventListener('resize', this.showTruncatedText);
    }
  },
  methods: {
    showText() {
      this.expanded = !this.expanded;
    },
    showTruncatedText() {
      this.isMobileView = window.innerWidth <= this.mobileScreenWidthEnd;
      this.isTextTruncated = this.isReadmoreEnabled && this.isMobileView;
    },
    getTruncatedText(text) {
      if (this.isTextTruncated && !this.expanded && text.length > this.charLimit) {
        return this.textToHTML(text.slice(0, this.charLimit));
      } else {
        return this.textToHTML(text);
      }
    },
    textToHTML(str) {
      var dom = document.createElement('div');
      dom.innerHTML = str;
      return dom.innerHTML;
    },
    getLineCount() {
      const description = this.proxy.description;
      const characterCount = description.length;

      this.buttonEnabled = characterCount > this.charLimit && this.isMobileView;
    },
  },
};
</script>
